import React, { useState, useContext } from "react";
import { UserContext } from "../../../contexts/UserContext"
import styles from "../styles/ListReviews.module.css";
import axios from "axios";
import Modal from "./../../../modal/Modal";
import { AddButtonShadow } from '../../../styles/buttons'
import ReviewModal from "./review-modal/ReviewModal";
import WarningModal from "./../../../modal/WarningModal";
import Tooltip from "../../../components/tooltip/Tooltip";

export default function ListReviews({ risk, setUpdateState, setShowControllerForm, setShowReviewForm, mirrorFromIcp }) {
  const [showModal, setShowModal] = useState(false);
  const [activeReview, setActiveReview] = useState(null);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const { activeUser } = useContext(UserContext)

  const deleteController = async () => {
    const res = await axios.delete(process.env.REACT_APP_IC_SERVICE + "/risk/delete-controller", {
      headers: {
        authorization: "Bearer " + activeUser.token,
      },
      data: {
        controllerId: activeReview,
        riskId: risk._id,
      },
    });
    setUpdateState((state) => !state);

    return res.status;
  };

  return (
    <>
      <Modal open={showModal} onClose={() => setShowModal(false)}>
        <ReviewModal
          setShowModal={setShowModal}
          risk={risk}
          activeReview={activeReview}
          setUpdateState={setUpdateState}
          mirrorFromIcp={mirrorFromIcp}
        />
      </Modal>
      <WarningModal
        passedFunction={() => deleteController()}
        warningTitle="Vill du verkligen ta bort kontrollen?"
        warningText="Allt arbete med kontrollen kommer gå förlorat"
        optionTextOne="Ta bort"
        optionTextTwo="Ångra"
        colour="red"
        open={showWarningModal}
        onClose={() => {
          setShowWarningModal(false);
        }}
      />

      <div className={styles.mainContainer}>
        <div className={styles.header}>Kontroller
          {mirrorFromIcp !== true ?
            <div style={{ position: "relative", left: "520px", top: "-25px", width: "200px" }}>
              <AddButtonShadow icp icon="add" onClick={() => {
                setShowReviewForm((status) => !status);
                setShowControllerForm(false);
              }}>Lägg till</AddButtonShadow>
            </div>
            : null}
        </div>
        {risk.controllers.filter((controller) => controller.icp).length > 0 ? (
          risk.controllers.filter((controller) => controller.icp)
            .map((controller) => (
              <div className={styles.oneControllerContainer} key={controller._id}>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setActiveReview(controller);
                    setShowModal(true);
                  }}
                >
                  {/* {controller.name} */}
                  {controller.name.length > 23 ?
                    <Tooltip content={controller.name} direction="right">{controller.name.slice(0, 23)}...</Tooltip>
                    : controller.name
                  }
                </div>
                <div className={styles.controllerColumnZero}>{controller.assignedUserId?.firstName} {controller.assignedUserId?.lastName}</div>
                <div className={styles.controllerColumnOne}><Tooltip content="Metod" direction="right">{controller.method}</Tooltip></div>
                <div className={styles.controllerColumnTwo}><Tooltip content="Frekvens" direction="right">{controller.frequency}</Tooltip></div>
                {mirrorFromIcp !== true ?
                  <div onClick={() => {
                    setActiveReview(controller._id)
                    setShowWarningModal(true)
                  }} className={styles.iconBox}>
                    <i className="fas fa-times fa-md sidebar-icon" />
                  </div>
                  : null}
              </div>
            ))
        ) : (
          <div className={styles.oneControllerContainer}>
            Det finns inga kontroller till den här risken!
          </div>
        )}
      </div>
    </>
  );
}
